export default function generateRandomId() {
  return String(Date.now()).slice(-4) + Math.floor(Math.random() * 1000);
}
